import duckIcon from "../images/icon.png"
import React from 'react';

const Footer = () => {

    return(
        <footer>
            <img src={duckIcon} width="30px"/>
            <p>Website by Cordii.T Creative</p>
        </footer>
    )
}

export default Footer;